<template>
  <div :style="
    'padding:' + options.data.pageCss.page_css_padding + 
    ';margin:' + options.data.pageCss.page_css_margin + 
    ';border-radius:' + options.data.pageCss.page_css_radius + 
    'px;background-color:' + options.data.pageCss.textBgc+';'+options.data.pageCss.myCss" class="article">
    <div @click="loadImg" id="img" class="article_html" v-html="options.data.desc||'请在右侧编辑文本'"></div>
    <slot></slot>
  </div>
</template>

<script>
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Article",
  props: ["index"],
  data() {
    return {
      viewer: null,
    };
  },
  watch: {
    "options.data.desc"() {
      this.$nextTick(() => {
        if (this.viewer) {
          this.viewer.update();
        }
      });
    },
  },
  computed: {
    ...mapGetters(["okForm"]),
    ...mapGetters(["workPlace"]),
    options() {
      return this.okForm[this.index]
        ? this.okForm[this.index].options
        : { data: this.workPlace.articleBox.data };
    },
  },
  mounted() {
    this.loadImg();
    window.addEventListener("popstate", this.closeViewer);
  },
  beforeDestroy() {
    window.removeEventListener("popstate", this.closeViewer);
    this.destroyViewer();
  },
  deactivated() {
    this.closeViewer();
  },
  methods: {
    // 关闭预览（不销毁实例，便于再次打开）
    closeViewer() {
      if (this.viewer) {
        this.viewer.hide();
      }
    },
    // 销毁实例，移除挂载在 body 上的 viewer 容器
    destroyViewer() {
      if (this.viewer) {
        try {
          this.viewer.hide(true);
          this.viewer.destroy();
        } catch (e) { }
        this.viewer = null;
      }
    },
    loadImg() {
      this.$nextTick(() => {
        const ViewerDom = document.getElementById("img");
        if (!ViewerDom) {
          return;
        }
        // 已存在实例时只刷新图片列表，避免重复创建容器
        if (this.viewer) {
          this.viewer.update();
          return;
        }
        this.viewer = new Viewer(ViewerDom, {
          url: "src",
          navbar: false,
          toolbar: false,
          zIndex: 99999,
          fullscreen: false,
          tooltip: false,
          scalable: false,
          rotatable: false,
          title: function (image) {
            // return image.alt + ' (' + (this.index + 1) + '/' + this.length + ')';
            return "";
          },
        });
      });
    },
  }
};
</script>

<style lang="less" scoped>
.article {
  max-width: 100%;
  padding: 2px;
  min-height: 100px;
  background-color: #fff;
}
.article_html {
  width: 100%;
  overflow: auto;
}
:deep(img) {
  max-width: 100% !important;
  height: unset;
}
</style>